import { FC } from "react";
import { Paragraph } from "@contentful/f36-components";
import { useSDK } from "@contentful/react-apps-toolkit";
import { useFetchDeeplUsage } from "../services";

export const DeeplUsageWidget: FC = () => {
    const sdk = useSDK();
    const deeplCredentials = sdk.parameters.installation.deeplApiKey;

    const { data } = useFetchDeeplUsage({ skip: !deeplCredentials });

    if (!deeplCredentials || !data) {
        return null;
    }

    const { character_count, character_limit } = data;

    return (
        <Paragraph marginBottom="none">
            {character_count.toLocaleString()} / {character_limit.toLocaleString()} chars used (
            {((100 * character_count) / character_limit).toFixed(2)}%)
        </Paragraph>
    );
};
